<table class="table table-hover table-striped">
  <thead>
    <tr>
      <th scope="col">
        <input
          class="form-check-input mt-0 me-3"
          type="checkbox"
          (change)="toggleAllRows()"
          [checked]="isAllSelected()"
          [indeterminate]="selected.length > 0 && !isAllSelected()"
        />
      </th>
      <th scope="col" class="cursor-pointer" (click)="sortBy('id')">
        {{ 'label.user-id' | translate }}
        <i
          class="bi"
          [class]="sortColumn === 'id' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
        </i>
      </th>
      <th scope="col" class="cursor-pointer" (click)="sortBy('firstname')">
        {{ 'label.firstname' | translate }}
        <i
          class="bi"
          [class]="sortColumn === 'firstname' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
        </i>
      </th>
      <th scope="col" class="cursor-pointer" (click)="sortBy('lastname')">
        {{ 'label.lastname' | translate }}
        <i
          class="bi"
          [class]="sortColumn === 'lastname' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
        </i>
      </th>
      <th scope="col" class="cursor-pointer" (click)="sortBy('email')">
        {{ 'label.email' | translate }}
        <i
          class="bi"
          [class]="sortColumn === 'email' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
        </i>
      </th>
      <th scope="col" class="cursor-pointer" (click)="sortBy('admin')">
        {{ 'label.role-admin' | translate }}
        <i
          class="bi"
          [class]="sortColumn === 'admin' ? (sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill') : 'bi-funnel-fill text-muted'">
        </i>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let row of items"
      [routerLink]="[row.id]"
      class="clickable cursor-pointer"
    >
      <td (click)="$event.stopPropagation()">
        <input
          class="form-check-input mt-0 me-3"
          type="checkbox"
          (change)="toggleRow(row)"
          [checked]="isSelected(row)"
        />
      </td>
      <td>{{ row.id }}</td>
      <td>{{ row.firstname }}</td>
      <td>{{ row.lastname }}</td>
      <td>{{ row.email }}</td>
      <td>
        <span *ngIf="row.admin" class="badge text-bg-primary">
          {{ 'label.role-admin' | translate }}
        </span>
      </td>
    </tr>
  </tbody>
</table>
